/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import Model, { helper } from '@tripian/model';
import Button from '../base/Button/Button';
import { ChevronRight, X } from '../base/Svg/Icons';
import classes from './StepTimes.scss';

export const oneHourForward = (hour: string) => {
  const split = hour.split(':');
  const add1Hour = (Number(split[0]) + 1).toString();
  const newHour = `${Number(add1Hour) < 10 ? `0${add1Hour}` : add1Hour}:${split[1]}`;
  return newHour;
};

const fromBiggerOrEqualThanTo = (from: string, to: string) => {
  const fromSplittedArr = from.split(':');
  const fromNumber = Number(`${fromSplittedArr[0]}${fromSplittedArr[1]}`);
  const toSplittedArr = to.split(':');
  const toNumber = Number(`${toSplittedArr[0]}${toSplittedArr[1]}`);

  if (fromNumber >= toNumber) {
    return true;
  }
  return false;
};

interface IStepTimes {
  times: { from?: string; to?: string };
  buttonText: string;
  duration?: string;
  timesClicked: (from?: string, to?: string) => void;
  onClose: () => void;
  t: (value: Model.TranslationKey) => string;
}

const StepTimes: React.FC<IStepTimes> = ({ times, buttonText, timesClicked, onClose, t }) => {
  const [timeFrame, setTimeFrame] = useState<{ from?: string; to?: string }>({ from: times.from, to: times.to });

  const fromOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const fromTimeBiggerOrEqualThanToTime = timeFrame.to ? fromBiggerOrEqualThanTo(e.target.value, timeFrame.to) : false;

    if (timeFrame.to === undefined || timeFrame.to === '' || fromTimeBiggerOrEqualThanToTime) {
      const newHour = oneHourForward(e.target.value);
      setTimeFrame({ from: e.target.value, to: newHour });
    } else {
      setTimeFrame({ ...timeFrame, from: e.target.value });
    }
  };

  const toOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (timeFrame.from === e.target.value) {
      const newHour = oneHourForward(e.target.value);
      setTimeFrame({ from: e.target.value, to: newHour });
    } else {
      setTimeFrame({ ...timeFrame, to: e.target.value });
    }
  };

  return (
    <div className={classes.stepTimesContent} role="button" tabIndex={0} onKeyPress={() => {}} onClick={(e) => e.stopPropagation()}>
      <div className={classes.header}>
        <div className={classes.title}>{t('trips.myTrips.itinerary.step.addToItinerary.title')}</div>
        <div
          className={classes.removeButton}
          onKeyDown={() => {}}
          role="button"
          tabIndex={0}
          onClick={(event) => {
            event.stopPropagation();
            onClose();
          }}
        >
          <X fill="#0B1215" />
        </div>
      </div>

      <div className={classes.content}>
        <div className={classes.timeContent}>
          <select id="startTime" className={classes.select} value={timeFrame.from} onChange={fromOnChange}>
            {timeFrame.from === undefined && <option value={undefined}>-- --</option>}
            {helper.startTimeRange().map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <span className="text-xl text-gray-800 pointer-events-none">
            <ChevronRight stroke="#000" />
          </span>
          <select id="endTime" className={classes.select} value={timeFrame.to} onChange={toOnChange}>
            {timeFrame.to === undefined && <option value={undefined}>-- --</option>}
            {helper.endTimeRange(timeFrame.from).map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <Button
          color="primary"
          className={classes.stepTimesButton}
          text={buttonText}
          disabled={!!timeFrame.from && !!timeFrame.to && times.from === timeFrame.from && times.to === timeFrame.to}
          onClick={(e) => {
            e.stopPropagation();
            timesClicked(timeFrame.from, timeFrame.to);
          }}
        />
      </div>
      {/* {duration && (
        <div className={classes.footer}>
          <Info fill="#5F6980" />
          <span className={classes.footerText}>
            {t('trips.myTrips.itinerary.step.addToItinerary.estimatedDuration')}: {duration}
          </span>
        </div>
      )} */}
    </div>
  );
};

export default StepTimes;
